@let apiResponse = data();
@if (apiResponse) {
  <div class="flex flex-col h-full">
    <div class="ml-2 mt-2 mb-4 text-xl">
      <b>Samlet opkrævning:</b> {{ apiResponse.sum | number: '1.2' }}
    </div>
    <div class="flex-1 overflow-hidden">
      <p-table
        [value]="apiResponse.data"
        [loading]="opkraevningService.datasource.isLoading()"
        [showGridlines]="true"
        [scrollable]="true"
        scrollHeight="flex"
        stripedRows
        class="p-datatable-sm lp-table"
        selectionMode="single"
        [metaKeySelection]="true"
        (onRowSelect)="onRowSelect($event)"
        dataKey="id"
        [lazy]="true"
        [lazyLoadOnInit]="false"
        (onLazyLoad)="onLazyLoad($event)"
        sortField="raadgiver.fornavn"
        [sortOrder]="1"
        [paginator]="true"
        [rows]="25"
        [totalRecords]="apiResponse.totalRowCount"
        [showJumpToPageDropdown]="true"
        letKeepScrollPosition>
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="id">
              Reference
              <p-sortIcon field="id" />
            </th>
            <th
              pSortableColumn="letsikringRevision.letsikring.kunde.intPengeinstitut.hovedRegNr">
              Regnr
              <p-sortIcon
                field="letsikringRevision.letsikring.kunde.intPengeinstitut.hovedRegNr" />
            </th>
            <th
              pSortableColumn="letsikringRevision.letsikring.kunde.intPersonOplysninger.cprNummer">
              CPR nr
              <p-sortIcon
                field="letsikringRevision.letsikring.kunde.intPersonOplysninger.cprNummer" />
            </th>
            <th pSortableColumn="letsikringNr">
              LetsikringNr
              <p-sortIcon field="letsikringNr" />
            </th>
            <th pSortableColumn="letsikringRevision.revisionNr">
              Revision
              <p-sortIcon field="letsikringRevision.revisionNr" />
            </th>
            <th pSortableColumn="periodeFra">
              Periode
              <p-sortIcon field="periodeFra" />
            </th>
            <th pSortableColumn="opkraevningsType">
              Type
              <p-sortIcon field="opkraevningsType" />
            </th>
            <th pSortableColumn="opkraevningsBeloeb">
              Beløb
              <p-sortIcon field="opkraevningsBeloeb" />
            </th>
            <th>Status</th>
          </tr>
        </ng-template>
        <ng-template [appTableRow]="apiResponse.data" pTemplate="body" let-item>
          <tr [pSelectableRow]="item" class="cursor-pointer">
            <td>{{ item.id }}</td>
            <td>{{ item.regnr }}</td>
            <td class="numbers">{{ item.cprNummer | cprNummer }}</td>
            <td>{{ item.letsikringNr }}</td>
            <td>{{ item.revisionNr }}</td>
            <td class="numbers">
              {{ item.periodeFra | date: 'dd-MM-yyyy' }} -
              {{ item.periodeTil | date: 'dd-MM-yyyy' }}
            </td>
            <td>{{ item.opkraevningsType }}</td>
            <td class="numbers !text-right">
              {{ item.opkraevningsBeloeb | number: '1.2' }}
            </td>
            <td>{{ item.opkraevningStatus }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
}
